// 自定义slideshow-arrows样式增强
class SlideshowArrowsCustom {
  constructor() {
    this.init();
  }

  init() {
    // 等待DOM加载完成
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupArrows());
    } else {
      this.setupArrows();
    }
  }

  setupArrows() {
    // 查找所有slideshow-arrows元素并添加自定义类
    const arrowsContainers = document.querySelectorAll('slideshow-arrows');
    
    arrowsContainers.forEach(container => {
      this.addCustomClasses(container);
    });

    // 延迟执行，确保DOM完全加载
    setTimeout(() => {
      this.setupArrows();
    }, 1000);
  }

  addCustomClasses(arrowsContainer) {
    const controls = arrowsContainer.querySelectorAll('.slideshow-control');
    
    if (controls.length >= 2) {
      // 第一个按钮是左边按钮（previous）
      const leftButton = controls[0];
      const rightButton = controls[1];
      
      // 移除可能存在的旧类
      leftButton.classList.remove('slideshow-control--next');
      rightButton.classList.remove('slideshow-control--previous');
      
      // 添加正确的类
      leftButton.classList.add('slideshow-control--previous');
      rightButton.classList.add('slideshow-control--next');
    }
  }
}

// 初始化
new SlideshowArrowsCustom();
